export default __webpack_public_path__ + "static/media/image-about-mission-m@2x.2598a9a5.webp";